// @flow

function paramToUrlQuery(param?: ?{ [string]: any }): string {
    const safeParam = param || {};
    return Object.keys(safeParam).reduce((acc, curr) => {
        return safeParam[curr]
            ? `${curr}=${encodeURIComponent(safeParam[curr])}`
            : "";
    }, "");
}

export function get(url: string, param?: ?{ [string]: any }) {
    if (url.indexOf("?") == -1) url += "?";
    url += paramToUrlQuery(param);
    return fetch(url, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        method: "GET"
    });
}

export function post(url: string, body: any) {
    return fetch(url, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(body)
    });
}



// WEBPACK FOOTER //
// ./src/_common/fetch.js